module.exports = __webpack_public_path__ + "static/media/NewsAggregator.c82e9755.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/NewsAggregator.jpg
// module id = 445
// module chunks = 0